module.exports = __webpack_public_path__ + "static/img/logo.9d1049c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/configure/next/logo.png
// module id = HGQU
// module chunks = 23